import * as headerBlock from '../header/';
import debounce from 'v-debounce';

const spinner = require('vue-strap').spinner;

export default {
  name: 'audits',
  components: { headerBlock, spinner },
  props: [
    'onLogout',
    'access_token',
    'authUser',
  ],
  mounted() {},
  data() {
    return {
      formData: {
        audits: [],
        auditsFields: {
          index: {
            label: '#',
            tdClass: 'text-center',
            thClass: 'text-center',
          },
          id: {
            label: 'ID',
            tdClass: 'text-center',
            thClass: 'text-center',
          },
          name: {
            label: 'Text',
            tdClass: 'text-left',
            thClass: 'text-center',
          },
          area: {
            label: 'Working area',
            tdClass: 'text-left',
            thClass: 'text-center',
          },
          permission: {
            label: 'Permission',
            // tdClass: 'text-left',
            thClass: 'text-center',
          },
        },
      },
      currentPage: 1,
      perPage: 10,
      areas: [],
      filter: '',
      breadCrumbItems: [
        {
          text: 'Home',
          to: `${process.env.START_URL}/`,
        }, {
          text: 'Audits',
          active: true,
        },
      ],
      processLoading: true,
    };
  },
  methods: {
    isInFilter(item) {
      return JSON.stringify(item).toLowerCase().indexOf(this.filter.toLowerCase()) + 1;
    },
    getAddAuditUrl() {
      return `${process.env.START_URL}/constructor/AuditConstructor`;
    },
    onRowClick(item) {
      this.$router.push({ name: 'Audit Configuration Change', params: { auditId: item.id } });
    },
    getAuditsTemplatesList() {
      let url = 'audit-templates/';
      if (this.$route.params.companyId) {
        url = `${url}?company=${this.$route.params.companyId}`;
      }
      return this.$http.get(url,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            return;
          }
          this.formData.audits = response.body;
          this.processLoading = false;
          return response.body;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    getWorkingAreas() {
      let url = 'areas/?is_system=false';
      if (this.$route.params.companyId) {
        url = `${url}&company=${this.$route.params.companyId}`;
      }
      this.$http.get(url,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            return;
          }
          this.areas = response.body;
          return response;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    getWorkingAreasListById(id, areas) {
      let result = [];
      for (let i = 0; i < areas.length; i++) {
        if (areas[i].id == id) {
          return result = [areas[i]];
        }
        result = this.getWorkingAreasListById(id, areas[i].subareas);
        if (result.length) {
          result.unshift(areas[i]);
          return result;
        }
      }
      return result;
    },
  },
  computed: {},
  created() {
    var self = this;
    this.getAuditsTemplatesList();
    this.getWorkingAreas();
  },
  directives: {
    debounce
  }
};



// WEBPACK FOOTER //
// ./src/components/audits/audits.component.js